var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"mt-2",staticStyle:{"flex":"none !important","height":"auto","width":"100%","object-fit":"cover"},attrs:{"src":(_vm.ws + "/compra/imagembem/" + _vm.idBem),"alt":_vm.alt}})}
var staticRenderFns = []

export { render, staticRenderFns }